import { render, staticRenderFns } from "./TemplatesForm.vue?vue&type=template&id=1aeafa72&scoped=true&"
import script from "./TemplatesForm.vue?vue&type=script&lang=js&"
export * from "./TemplatesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aeafa72",
  null
  
)

export default component.exports